var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-data-table',{attrs:{"id":_vm.id,"titles":_vm.titles,"bus":_vm.bus,"props":_vm.props,"endpoint":_vm.endpoint,"endpointParams":_vm.endpointParams,"cols":_vm.cols,"header":1,"paging":1,"page-length":20,"searching":0,"order-column":"1","order-dir":"asc"}})
}
var staticRenderFns = []

export { render, staticRenderFns }